import { CheckListReq } from "@/types/Px";
import { Ref, ref, computed } from "vue";

/*
 * 初期処理
 */
export function useInit() {
    const loading = ref(0) // APIで読み込みをする本数
    const isError = ref(false)

    const form:Ref<CheckListReq> = ref({
        year: null,
        month: null,
        shime: null,
    });

    // 読み込み中か判断する
    const isLoading = computed(() => {
        return !(loading.value === 0 || isError.value)
    })

    return {
        form,
        isLoading,
        isError,
    }
}
